import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import BaseStyles, { PREFIX } from './base';
import { css } from 'styled-components';
import { DARK_COLORS } from './dark';

const {
    mlbBlack,
    mlbGrey5,
    mlbGrey4,
    mlbGrey3,
    mlbWhite,
    mlbGrey2,
    mlbGrey1,
    blueRibbon,
    linkBlue,
    linkBlueOnDark,
    liveBlue,
    libertyBlue,
    skeletonLightMain,
    skeletonLightHighlight,
    wrapBlue
} = COLORS;

/* to be tokenized with react patterns upgrades */
export const alertRed = '#AA0013';
const positiveGreen = '#006C00';
const primaryBlack = '#070A0D';
const secondaryGrey = '#57606C';
const dividerColor = '#E8EAED';
const backgroundColor = '#FFFFFF';
const alertYellow = '#E0A561';
const alertBlue = '#0062E3';

const LightStyles = css`
  ${BaseStyles}
  :scope {
    --${PREFIX}-primary-font-color: ${mlbBlack};
    --${PREFIX}-secondary-font-color: ${mlbGrey5};
    --${PREFIX}-tab-button-inactive-color: ${mlbGrey4};
    --${PREFIX}-tab-button-active-color: ${mlbBlack};
    --${PREFIX}-title-color: ${mlbGrey4};
    --${PREFIX}-recap-color: ${mlbBlack};
    --${PREFIX}-video-carousel-more-background: ${mlbWhite};
    --${PREFIX}-background-color: ${mlbWhite};
    --${PREFIX}-play-dot-background: ${mlbWhite};
    --${PREFIX}-play-outs-color: ${mlbGrey5};
    --${PREFIX}-summary-play-event-color: ${mlbGrey5};
    --${PREFIX}-top-performer-stat-color: ${mlbGrey5};
    --${PREFIX}-summary-play-event-border-color: ${mlbGrey2};
    --${PREFIX}-morecoverage-date-color: ${mlbGrey4};
    --${PREFIX}-footerlink-color: ${mlbBlack};
    --${PREFIX}-filter-button-bgcolor: ${mlbGrey2};
    --${PREFIX}-filter-button-border: ${mlbGrey4};
    --${PREFIX}-filter-button-fontcolor: ${mlbBlack};
    --${PREFIX}-filter-button-hover-bgcolor: ${mlbBlack};
    --${PREFIX}-filter-button-hover-border: ${mlbBlack};
    --${PREFIX}-filter-button-hover-fontcolor: ${mlbWhite};
    --${PREFIX}-medlialinks_title-color: ${mlbBlack};
    --${PREFIX}-broadcaster-text-color: ${mlbGrey5};
    --${PREFIX}-boxscore-thead-color: ${mlbGrey5};
    --${PREFIX}-boxscore-tbody-color: ${mlbBlack};
    --${PREFIX}-boxscore-border-color: #eeeeee;
    --${PREFIX}-panel-border-color: ${mlbGrey2};
    --${PREFIX}-panel-svg-fill: ${mlbGrey4};
    --${PREFIX}-decisions-pipe-color: ${mlbGrey2};
    --${PREFIX}-decisions-stats-color: ${mlbGrey5};
    --${PREFIX}-ls-decisions-border-color: ${mlbGrey2};
    --${PREFIX}-firstpitch-event-color: ${mlbGrey5};
    --${PREFIX}-live-background-color: #F5F5F5;
    --${PREFIX}-live-element-background-color: ${mlbWhite};
    --${PREFIX}-boxscore-player-link-color: ${mlbBlack};
    --${PREFIX}-divider-color: ${mlbGrey2};
    --${PREFIX}-matchup-outline-color: ${mlbWhite};
    --${PREFIX}-basepath-inactive-color: ${mlbGrey4};
    --${PREFIX}-hover-close-color: ${mlbWhite};
    --${PREFIX}-overlay-background-color: ${mlbWhite};
    --${PREFIX}-summary-play-icon-color: ${mlbGrey5};
    --${PREFIX}-team-stats-footer-color: ${mlbGrey3};
    --${PREFIX}-header-menu-border-color: ${mlbGrey1};
    --${PREFIX}-gameover-divider-color: #eeeeee;
    --${PREFIX}-wrap-section-divider: ${mlbGrey2};
    --${PREFIX}-play-dot-border: ${mlbGrey2};
    --${PREFIX}-card-title-color: ${mlbBlack};
    --${PREFIX}-fv-how-to-title-color: #333333;
    --${PREFIX}-summary-event-score-color: ${wrapBlue};
    --${PREFIX}-link-color: ${linkBlue};
    --${PREFIX}-audio-list-link-hover-color: ${liveBlue};
    --${PREFIX}-green: ${positiveGreen};
    --${PREFIX}-red: ${alertRed};
    --${PREFIX}-film-room-font: ${wrapBlue};
    --${PREFIX}-skeleton-background: ${skeletonLightMain};
    --${PREFIX}-skeleton-highlight: ${skeletonLightHighlight};
    --${PREFIX}-oot-scoreboard-border-hover: ${libertyBlue};
    --${PREFIX}-oot-scoreboard-border-selected: ${libertyBlue};
    --${PREFIX}-oot-scoreboard-border-disabled: #C4C4C4;
    --${PREFIX}-fv-login-link-color: ${blueRibbon};
    --${PREFIX}-fv-login-password-modal-bg: ${mlbGrey1};
    --${PREFIX}-fv-login-password-modal-text: ${mlbGrey4};
    --${PREFIX}-fv-login-error-message-bg: #f4dedc;
    --${PREFIX}-fv-login-error-message-text: #9f3b32;
    --${PREFIX}-scoreboard-notable-game-highlight: ${linkBlueOnDark};
    --${PREFIX}-video-carousel-button-color: ${mlbWhite};
    --${PREFIX}-video-carousel-button-color-hover: ${mlbGrey2};
    --${PREFIX}-table-active-cell-color: rgba(221, 221, 221, 0.33);
    --${PREFIX}-highlight-active-color: ${blueRibbon};
    --${PREFIX}-button-solid-background: ${wrapBlue};
    --${PREFIX}-button-solid-text-color: mlbWhite;
    --${PREFIX}-button-hollow-background: transparent;
    --${PREFIX}-button-hollow-text: ${wrapBlue};
    --${PREFIX}-button-hollow-border: ${wrapBlue};
    --${PREFIX}-team-comparison-secondary-font-color: ${mlbGrey5};
    --${PREFIX}-wrap-seeall-color: ${mlbBlack};
    --${PREFIX}-fv-how-to-img-filter: 0;
    --${PREFIX}-overlay-opacity: 0.35;
    --${PREFIX}-overlay-midinning-opacity: 0.175;
    --${PREFIX}-scoreboard-button-color: ${mlbBlack};
    --${PREFIX}-accordion-indicator-color: ${wrapBlue};
    --${PREFIX}-dfvbuttons-bg-color: ${mlbGrey2};
    --${PREFIX}-dfvbuttons-active-color: ${mlbWhite};
    --${PREFIX}-dfvbuttons-active-text-color: ${mlbBlack};
    --${PREFIX}-dfv-batterview-text-color: ${mlbWhite};
    --${PREFIX}-dfv-batterview-bg-color: ${DARK_COLORS.grey3};
    --${PREFIX}-gamepicker-button-disabled: ${mlbGrey3};
    --${PREFIX}-basepath-color: ${mlbBlack};
    --${PREFIX}-outs-color: ${mlbBlack};
    --${PREFIX}-active-icon-button-color: ${mlbBlack};
    --${PREFIX}-inactive-icon-button-color: ${mlbGrey4};
    --${PREFIX}-toast-background-color: ${mlbWhite};
    --${PREFIX}-toast-border-color: ${mlbGrey2};

    --${PREFIX}-alert-red: ${alertRed};
    --${PREFIX}-game-context-button-color: ${primaryBlack};
    --${PREFIX}-game-context-primary-text-color: ${primaryBlack};
    --${PREFIX}-game-context-secondary-text-color: ${secondaryGrey};
    --${PREFIX}-game-context-divider-color: ${dividerColor};
    --${PREFIX}-game-context-background-color: ${backgroundColor};
    --${PREFIX}-ticket-button-color: ${positiveGreen};
    --${PREFIX}-tag-label-background: ${primaryBlack};
    --${PREFIX}-tag-label-text: ${mlbWhite};
    --${PREFIX}-game-context-primary: ${primaryBlack};
    --${PREFIX}-alert-yellow: ${alertYellow};
    --${PREFIX}-alert-blue: ${alertBlue};
    --${PREFIX}-error-fallback-button-text: ${mlbWhite};
    --${PREFIX}-error-fallback-button-background: ${primaryBlack};
    --${PREFIX}-error-fallback-button-disabled: ${mlbGrey3};
    color-scheme: light;
    body {
        background-color: #F5F5F5;
    }

  }
`;

export default LightStyles;
